import App from "./App";
import React, { StrictMode } from "react";
import ReactDOM from "react-dom/client";
import { store } from "./Redux/Store/Store.js";
import { Provider } from "react-redux";
import * as serviceWorkerRegistration from "./serviceWorkerRegistration";
import { ToastContainer } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
const root = ReactDOM.createRoot(document.getElementById("cms_app_root"));

root.render(
  <StrictMode>
    <Provider store={store}>
      <App />
      <ToastContainer />
    </Provider>
  </StrictMode>
);
serviceWorkerRegistration.register();
